import * as React from "react";
import { sendPrm } from "tyrande/lib/prm";
// 组件模块
import MMagicBanner from "./MMagicBanner";
import MNavigation from "./MNavigation";
import MTypography from "./MTypography";
import MCarouselBanner from "./MCarouselBanner";
import MCountdownBanner from "./MCountdownBanner";
import { default as SlidingCardBanner } from "./CardBanner/Sliding";
import { default as RollableCardBanner } from "./CardBanner/RollOver";
import { default as MCudeBannerZoom } from "./CudeBanner/Zoom";
import { default as MCudeBannerBase } from "./CudeBanner/RollOver";
import NormalProduct from "./NormalProduct";
import MCouponCode, { CouponProps } from "./MCouponCode";
import ErrorPage from "./ErrorPage";
// 方法，类型
import { CommonRuntime } from "utils/runtime";
import {
	DTPlatform,
	getModuleData,
	getValidDataByPlatfrom,
	refreshCountDownModule,
} from "utils/playground/module";
import { PrmParams, sendPrmByUrl } from "utils/prm";
import { getSite, isLinkHasNewWindow } from "utils/url";
import {
	TModule,
	TModuleType,
	TTextModule,
	CouponType,
	Layout,
	TPlatform,
} from "services/page/admin";
import { TFrontModule } from "services/page/app";
import { ModuleInteraction } from "services/page/common";
import {
	TCombinedProductModule,
	TCombinedProductCommonExtend,
	TMagicBanner,
	TMultiBanner,
	TCDBannerExtend,
	TCombinedMultiBannerModule,
	TCombinedCouponCommonExtend,
} from "services/page/modules";
import {
	transformBanner,
	transformBanners,
	getCardBannerItemSize,
	bannerPlaceholder,
	bannerPlaceholder456,
	transformMagicLinks,
	tranformCouponInfo,
} from "utils/playground/banner";
import {
	handleProductModuleParam,
	fetchMProductCardStyle,
	setProductDisplayInfo,
} from "utils/playground/product";
import { getLitbLangFn } from "utils/language";
import { multilingualTextDisplay } from "utils/mutil-Language";
import { MainProps } from "../../index";
import { ParseProductTagFromUrlResp } from "utils/playground/url";
import { jumpToLogin } from "utils/login";
import { getGetCoupons } from "utils/zeusFetch";
import { TCountdownModule, TModuleWithImgProps } from "views/services/playground";
import { BigBannerPlaceholder } from "views/utils/imgUrls";

export interface CommonProps {
	id: string;
}

interface ModuleProps {
	index: number;
	stickToTop?: number;
	id: string;
	positionId: string;
	moduleDetail: TModule;
	runtime: CommonRuntime;
	canScrollFixed: boolean;
	tagQuery: ParseProductTagFromUrlResp;
}

const Module = function Module(props: ModuleProps) {
	const { positionId, index, moduleDetail, runtime } = props;
	const { languageCode, platform } = runtime;
	// tslint:disable-next-line
	const { type, header, ui } = moduleDetail;
	let { layout } = moduleDetail;
	// const interaction = moduleDetail.layout?.interaction;

	const PrmCommonParams: PrmParams = {
		floor: index + 1,
		position: 1,
	};
	const commonModuleData = getModuleData(moduleDetail);
	const moduleData: { [key: string]: any } = getValidDataByPlatfrom(
		commonModuleData,
		DTPlatform.M,
	);
	const modProps: TModuleWithImgProps = {
		key: positionId,
		positionId,
		online: true,
		stickToTop: props.stickToTop,
		placeholderBg: bannerPlaceholder,
		isInApp: runtime.isInApp,
		language: runtime.languageCode,
	};

	switch (type) {
		case TModuleType.TQuickNav:
			const navContent = (
				moduleDetail.module as typeof moduleDetail.module & TCombinedMultiBannerModule
			).mobile;
			return (
				<MNavigation
					{...modProps}
					texts={
						(navContent?.banners || [])?.map((n) => {
							return {
								link: n.link,
								content: n.title,
							};
						}) as any
					}
					navFixed={navContent?.layout?.stickToTop}
				/>
			);
		case TModuleType.TNewMultiBanner:
			const multi_data: TMultiBanner = moduleData;
			const tBanners = transformBanners(multi_data?.banners || [], runtime, {
				...PrmCommonParams,
			});
			// 解决导购滑动模块问题
			const interaction = multi_data?.layout.interaction;
			if (interaction === ModuleInteraction.RollOver) {
				return (
					<RollableCardBanner
						cardBanners={[...tBanners]}
						{...modProps}
						viewMore={{
							link: header.link,
							text: getLitbLangFn("View More", languageCode),
						}}
					/>
				);
			}
			if (interaction === ModuleInteraction.SingleSliding) {
				const { itemHeight: cardHeight, itemWidth: cardWidth } = getCardBannerItemSize(
					tBanners?.[0]?.height,
				);
				return (
					<SlidingCardBanner
						{...modProps}
						cardBanners={[...tBanners]}
						cardSize={{ cardWidth, cardHeight }}
					/>
				);
			}
			if (interaction === ModuleInteraction.Zoom) {
				return (
					<MCudeBannerZoom
						{...modProps}
						elements={[...tBanners]}
						placeholderBg={bannerPlaceholder456}
					/>
				);
			}
			if (interaction === ModuleInteraction.ZoomSliding) {
				return (
					<MCudeBannerBase
						{...modProps}
						elements={[...tBanners]}
						placeholderBg={bannerPlaceholder456}
					/>
				);
			}
			return (
				<MCarouselBanner
					{...modProps}
					elements={[...tBanners]}
					placeholderBg={bannerPlaceholder456}
				/>
			);
		// 👇 MagicBanner
		case TModuleType.TNewMagicBanner:
			const magicModule: TMagicBanner = moduleData;
			const magicBanner = transformBanner({ ...magicModule.banners[0] }, runtime, {
				...PrmCommonParams,
			});
			const magicModuleItems: any = transformMagicLinks(index, runtime, magicModule.items);
			return (
				<MMagicBanner
					{...modProps}
					banner={magicBanner}
					onClick={sendPrmByUrl}
					linkItems={magicModuleItems}
					placeholderBg={bannerPlaceholder456}
					moduleIndex={index}
				/>
			);

		case TModuleType.TNewMultiProduct:
			const productModule: TCombinedProductModule = commonModuleData;
			let moduleExtend: TCombinedProductCommonExtend = {
				ui,
				layout,
			};
			if (productModule?.mobile) {
				moduleExtend = (productModule as TCombinedProductModule).mobile;
				layout = layout = moduleExtend?.layout;
			}

			const isRollable = layout?.interaction === ModuleInteraction.RollOver;
			const productProps = handleProductModuleParam({
				defaultVal: {
					...modProps,
					layout: { ...(layout as Required<Layout>), gap: 0.5, parentGap: 0.75 },
				},
				module: productModule,
				runtime,
				prm: PrmCommonParams,
				header,
				extend: moduleExtend,
				tagQuery: props.tagQuery,
				isRollable,
			});
			return (
				<NormalProduct
					{...productProps}
					isRollable={isRollable}
					canScrollFixed={props.canScrollFixed}
					scoreOptions={{ ...productProps?.scoreOptions, height: "0.625rem" }}
					viewMore={getLitbLangFn("View More", languageCode)}
					stylesForCard={fetchMProductCardStyle({
						col: layout.columnNum,
						shape: moduleExtend?.ui?.shape,
					})}
					productDisplayInfo={setProductDisplayInfo({
						isRollable,
						platform: TPlatform.Mobile,
						layout: { columnNum: layout.columnNum },
						currency: runtime?.currency,
					})}
					runtime={runtime}
				/>
			);
		case TModuleType.TNewCountdown:
			const countDownModule: TCDBannerExtend = moduleData;
			const cBanner = transformBanner({ ...countDownModule.banner }, runtime, {
				...PrmCommonParams,
			});
			return (
				<MCountdownBanner
					{...modProps}
					banner={cBanner}
					timer={countDownModule.timer as TCountdownModule}
					actState={countDownModule.state as any}
					onRefresh={refreshCountDownModule(moduleDetail?.id, {
						runtime,
						prm: PrmCommonParams,
					})}
					moduleIndex={index}
				/>
			);
		case TModuleType.TRichText:
			const textModule = moduleData as TTextModule;
			const textContent = multilingualTextDisplay(textModule, languageCode);
			return (
				<MTypography {...modProps} bgColor={ui?.bgColor || "#fff"} content={textContent} />
			);
		case TModuleType.TNewCoupon:
			const cpoponModule: TCombinedCouponCommonExtend = moduleData;
			const couponProps: CouponProps = {
				...modProps,
				spmClick: (order: number) => {
					sendPrm({
						site: getSite(platform),
						page: "65",
						part: index + 1,
						content: order,
					});
				},
				coupons: tranformCouponInfo(cpoponModule?.coupons, runtime),
				columnSize: cpoponModule?.layout?.columnNum,
				type: cpoponModule?.couponType || CouponType.CopyCoupon,
				getCoupons: async (code: string) => {
					if (!runtime?.sessionKey) {
						return jumpToLogin({
							isUat: runtime.isUat,
							isInApp: runtime.isInApp,
							isMobile: true,
							aTarget: isLinkHasNewWindow(runtime),
						});
					}

					return getGetCoupons(
						{
							isUat: runtime?.isUat ? "true" : undefined,
							campaign_key: code || undefined,
							sid: runtime?.sid || "",
							sessionkey: runtime?.sessionKey || "",
							language: languageCode,
							currency: runtime?.currency,
							country: runtime?.countryCode3,
						},
						true,
						runtime.isUat,
					);
				},
			};
			return <MCouponCode {...couponProps} />;
		default:
			return null;
	}
}

interface MobileState {
	moduleList: TFrontModule[];
	hasTitle?: boolean; // admin是否配置了pageTitle，app中默认不显示pageTitle
	pageDisabled: boolean;
	activityId: string;
}

/**
 * （1）是否有title(在app中默认灭有title)
 * （2）是否在App中
 *  (3)是否有nav
 *
 * nav 默认不会吸顶，product的tab默认吸顶
 *
 * 用到锚点定位的地方；nav的点击、nav组件中滚动的时候，需要同步高亮对应的tab、magic banner中配置内链、
 *
 * 锚点相关测试点：有无title、nav和magicbanner的定位、product模块吸顶，切换tab是否滚动到最顶部
 *
 */
class MegatronFrontForMobile extends React.Component<MainProps, MobileState> {
	constructor(props: MainProps) {
		super(props);

		if (props.page) {
			const { modules = [], page } = this.props;
			this.state = {
				moduleList: modules,
				pageDisabled: page && page.isDisable,
				activityId: page && page.groupId,
			};
			return;
		}

		this.state = {
			moduleList: null,
			pageDisabled: false,
			activityId: "",
		};
	}

	render() {
		const { runtime, frontModules, tagQuery } = this.props;
		const { moduleList, pageDisabled } = this.state;
		if (!moduleList) {
			return (
				<img src={`${BigBannerPlaceholder}`} style={{ width: "100%" }} alt="placeholder" />
			);
		}
		if (!moduleList) {
			return null;
		}
		if ((moduleList && moduleList.length === 0) || pageDisabled) {
			return <ErrorPage language={runtime.languageCode} />;
		}
		const navFixed = frontModules.find((m) => m.type === TModuleType.TQuickNav)?.module?.mobile
			?.layout?.stickToTop;
		return (
			<React.Fragment>
				{frontModules.map((item: TModule, i: number) => {
					return (
						<Module
							key={i}
							index={i}
							id={item.id}
							positionId={item.header?.position}
							moduleDetail={item}
							stickToTop={0}
							canScrollFixed={!navFixed}
							runtime={runtime}
							tagQuery={tagQuery}
						/>
					);
				})}
			</React.Fragment>
		);
	}
}

export default MegatronFrontForMobile;
